import {
  LOAN_ENDPOINTS,
  OTP_ENDPOINTS
} from "../constants/apiEndpoints";
import {
  getWrapper,
  getWrapperWeb,
  postWrapper,
  postWrapperWeb,
  postWrapperWebFile
} from "../utils/Wrapper";
import { getLocationForPayload } from "../utils/locationUtils";
import { getWrapperFile } from "../utils/Wrapper";

export const getApplicationDetails = (applicationId, documentId) => {
  let url = `${LOAN_ENDPOINTS.GET_APPLICATION_DETAILS}?applicationId=${encodeURIComponent(
    applicationId
  )}`;

  if (documentId) {
    url += `&documentId=${encodeURIComponent(documentId)}`;
  }
  return getWrapper(url);
};

export const getAllLoanApplications = (userId) => {
  let url = `${LOAN_ENDPOINTS.GET_ALL}${userId? `?userId=${userId}` : ""}`;
  return getWrapper(url);
};

export const getAllProposalsCustomized = (page = 0, size = 10, sortBy, order, searchQuery) => {
  const params = new URLSearchParams();
  params.append("page", page);
  params.append("size", size);
  if (sortBy) params.append("sortBy", sortBy);
  if (order) params.append("order", order);
  if (searchQuery) params.append("searchQuery", searchQuery);
  
  const url = `${LOAN_ENDPOINTS.GET_ALL_PROPOSALS_CUSTOMIZED}?${params.toString()}`;
  return getWrapper(url);
};

export const getResumedApplications = (userId) => {
  let url = `/api/loan/resume?userId=${userId}`;
  return getWrapperWeb(url);
};

export const getResumeProposals = (page = 0, size = 10, sortBy, order, searchQuery) => {
  const params = new URLSearchParams();
  params.append("page", page);
  params.append("size", size);
  if (sortBy) params.append("sortBy", sortBy);
  if (order) params.append("order", order);
  if (searchQuery) params.append("searchQuery", searchQuery);

  const url = `/api/loan/get-resume?${params.toString()}`;
  return getWrapper(url);
};

export const applyLoan = (data) => {
  let url = "/api/loan/apply";
  return postWrapperWeb(url, data);
};

export const sendOTP = (data) => {
      // Get location data from the Redux store
  const locationData = getLocationForPayload();

  const payload = {
    mobileNumber: data.mobileNumber,
    ip: locationData.ip,
    longitude: locationData.longitude,
    latitude: locationData.latitude,
    ...(data.email && { email: data.email }),
  };

  const url = `${OTP_ENDPOINTS.SEND_OTP}`;
  return postWrapper(url, payload);
};



export const verifyOTP = (verifyData) => {
  const url = `/${OTP_ENDPOINTS.VERIFY_OTP}?mobileNumber=${
    verifyData.mobileNumber
  }&mobileOtp=${verifyData.mobileOtp}${
    verifyData.email
      ? `&email=${verifyData.email}&emailOtp=${verifyData.emailOtp}`
      : ""
  }`;
  return postWrapper(url, {});
};

export const resendOTP = (resendData) => {
  const locationData = getLocationForPayload();

  const payload = {
    mobileNumber: resendData.mobileNumber,
    ip: locationData.ip,
    longitude: locationData.longitude,
    latitude: locationData.latitude,
    ...(resendData.email && { email: resendData.email }),
  };

  const url = `${OTP_ENDPOINTS.RESEND_OTP}`;

  return postWrapper(url, payload);
};

export const uploadDoc = (data) => {
  let url = "/api/loan/docx-upload";
  return postWrapper(url, data);
};

export const notify = (data) => {
  let url = "/api/notify";
  return postWrapper(url, data);
};

export const getOnePager = (applicationId) => {
  if (!applicationId) {
    return Promise.reject(new Error("Application ID is required to generate one pager"));
  }

  const formData = new FormData();
  formData.append("applicationId", applicationId);

  const url = `/api/onepager`;
  return postWrapperWebFile(url, formData);
};

export const getOnePagerByAppNumber = (applicationInfo, additionalParams = {}) => {
  const appId = applicationInfo?.applicationId ?? applicationInfo?.applicationNumber ?? applicationInfo;

  const appNumber = String(appId ?? '').trim();

  if (!appNumber) {
    return Promise.reject(new Error("Application ID is required to generate one pager"));
  }

  const params = new URLSearchParams({ applicationNumber: appNumber });
  Object.entries(additionalParams).forEach(([key, value]) => {
    if (value != null) params.append(key, String(value));
  });

  return postWrapperWebFile(`/api/one-pager?${params.toString()}`, null);
};

export const generateCMA = (applicationInfo) => {
  const appId = applicationInfo?.applicationId ?? applicationInfo?.applicationNumber ?? applicationInfo;

  const appNumber = String(appId ?? '').trim();

  if (!appNumber) {
    return Promise.reject(new Error("Application ID is required to generate CMA report"));
  }

  const params = new URLSearchParams({ applicationNumber: appNumber });
  return postWrapperWebFile(`/api/cma?${params.toString()}`, null);
};

export const getS3UrlByKeyBase64 = (keyBase64) => {
  if (!keyBase64) {
    return Promise.reject(new Error("S3 key is required"));
  }

  const url = `/s3/get-url/${keyBase64}`;
  return getWrapper(url);
};

export const fetchCompanyDetailbyGst = (gst) => {
  let url = `/api/get-company-details?gst=${gst}`;
  return getWrapperWeb(url);
};

export const fetchCompanyDetailbyCIN = (cin) => {
  let url = `/api/get-company-summary?cinNumber=${cin}`;
  return getWrapperWeb(url);
};

export const fetchCompanyDocbyCIN = (cin) => {
  let url = `/api/order?cinNumber=${cin}`;
  return postWrapperWeb(url, {});
};


export const fetchCMADetails = (applicationId) => {
  let url = `/ocr/cma-report/${applicationId}`;
  return postWrapperWeb(url, {});
};

export const getIndustries = () => {
  let url = `/industry/industry`;
  return getWrapperWeb(url);
};

export const getSectors = (industry) => {
  let url = `/industry/sector?industry=${industry}`;
  return getWrapperWeb(url);
};

export const getLocationByPincode = (pincode) => {
  let url = `https://api.postalpincode.in/pincode/${encodeURIComponent((pincode || "").toString().trim())}`;
  return getWrapper(url, true);
}


export const downloadAllDocuments = (applicationId) => {
  const url = `${LOAN_ENDPOINTS.DOWNLOAD_DOCUMENTS}?applicationId=${encodeURIComponent(applicationId)}`;
  return getWrapperFile(url);
};

